<template>
  <div class="login-page">
    <smart-gas-background variant="login" />
    <div class="login-card">
      <img src="/logo.png" alt="logo" class="login-logo" />
      <h2>智慧燃气综合管理平台</h2>
      <p class="sub">上海晟颢信息科技有限公司</p>
      <p class="portal-link"><router-link to="/">返回系统门户</router-link></p>
      <el-form ref="form" :model="form" :rules="rules" @submit.native.prevent="onSubmit">
        <el-form-item prop="username">
          <el-input v-model="form.username" prefix-icon="el-icon-user" placeholder="用户名" />
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="form.password" prefix-icon="el-icon-lock" type="password" placeholder="密码" show-password />
        </el-form-item>
        <el-button type="primary" style="width:100%;" :loading="loading" @click="onSubmit">登录</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import SmartGasBackground from '@/components/SmartGasBackground.vue'
import request from '@/utils/request'
import { goAdminHome } from '@/router'

export default {
  components: { SmartGasBackground },
  data() {
    return {
      loading: false,
      form: { username: 'admin', password: 'admin123' },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.loading = true
        try {
          const res = await request.post('/auth/login', {
            username: this.form.username,
            password: this.form.password,
            clientType: 'admin'
          })
          this.$store.commit('SET_TOKEN', res.data.token)
          this.$store.commit('SET_NAME', res.data.user.name || res.data.user.username)
          await goAdminHome()
        } catch (e) {
          if (this.$store.state.token) {
            this.$message.error('进入后台失败，请检查后端服务')
          } else {
            this.$message.error('登录失败，请检查账号和密码')
          }
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>
